import type { SVGProps } from 'react';

interface SourcesIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function SourcesIcon({ className, ...props }: SourcesIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="4.5 4.5 15.0 15.0"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path d="M9.59375 6C10.0131 6 10.4152 6.16948 10.708 6.46973L11.8857 7.67773C11.9406 7.73392 12.0111 7.77172 12.0869 7.78711L12.1641 7.79492H16.667C17.9554 7.7951 18.9999 8.8395 19 10.1279V16.1113C18.9999 17.3998 17.9554 18.4442 16.667 18.4443H7.33301C6.04457 18.4442 5.00012 17.3998 5 16.1113V8.33301C5.00018 7.0446 6.0446 6.00018 7.33301 6H9.59375ZM7.33301 7.39941C6.8178 7.39959 6.39959 7.8178 6.39941 8.33301V16.1113C6.39953 16.6266 6.81776 17.0447 7.33301 17.0449H16.667C17.1822 17.0447 17.6005 16.6266 17.6006 16.1113V10.1279C17.6004 9.6127 17.1822 9.19451 16.667 9.19434H12.1641C11.6818 9.19434 11.2205 8.99957 10.8838 8.6543L9.70508 7.44727C9.67581 7.41727 9.63567 7.39941 9.59375 7.39941H7.33301ZM13.167 13.6611C13.5534 13.6613 13.8672 13.9748 13.8672 14.3613C13.8671 14.7477 13.5534 15.0613 13.167 15.0615H8.5C8.11347 15.0615 7.79992 14.7478 7.7998 14.3613C7.7998 13.9747 8.1134 13.6611 8.5 13.6611H13.167ZM15.5 10.9385C15.8865 10.9385 16.2001 11.2522 16.2002 11.6387C16.2002 12.0253 15.8866 12.3389 15.5 12.3389H8.5C8.1134 12.3389 7.7998 12.0253 7.7998 11.6387C7.79992 11.2522 8.11347 10.9385 8.5 10.9385H15.5Z" fill="currentColor"/>
    </svg>
  );
}
